<template>
  <div class="pad20 flex flex-item1 mar20-b border">
    <div class="item flex-shrink">
      <div class="fb f16 mar15-b">付款信息</div>
      <div class="flex">
        <div class="w80 mar10-b gray6">支付类型</div>
        <div class="flex-auto mar10-b">{{ detail.paymentTypeCn }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b gray6">支付状态</div>
        <div class="flex-auto mar10-b">{{ detail.paymentStCn }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b gray6">结算状态</div>
        <div class="flex-auto mar10-b">{{ detail.balanceStCn }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b gray6">下单时间</div>
        <div class="flex-auto mar10-b">{{ detail.orderTime }}</div>
      </div>
      <div class="flex" v-if="detail.paymentTime">
        <div class="w80 mar10-b gray6">支付时间</div>
        <div class="flex-auto mar10-b">{{ detail.paymentTime }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b gray6">订单金额</div>
        <div class="flex-auto mar10-b" v-if="dataMasking">****</div>
        <div class="flex-auto mar10-b" v-else>
          <div>{{ detail.fmoney ? parseFloat(detail.fmoney.toString()).toFixed(2) : "0.00" }}</div>
          <div>
            （含运费
            {{ detail.freightMoney ? parseFloat(detail.freightMoney.toString()).toFixed(2) : "0.00" }}
            ）
          </div>
        </div>
      </div>
    </div>
    <div class="item flex-shrink border-l pad20-l">
      <div class="fb f16 mar15-b">收货人信息</div>
      <div class="flex">
        <div class="w80 mar10-b gray6">{{ detail.delivery == "2" ? "自提人" : "收货人" }}</div>
        <div class="flex-auto mar10-b" v-if="dataMasking">
          {{ detail.orderTransportDtlBo.linkman.substring(0, 1) + new Array(detail.orderTransportDtlBo.linkman.length).join("*") }}
        </div>
        <div class="flex-auto mar10-b" v-else>{{ detail.orderTransportDtlBo.linkman }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b gray6">电话</div>
        <div class="flex-auto mar10-b">{{ detail.orderTransportDtlBo.tel }}</div>
      </div>
      <div class="flex">
        <div class="w80 mar10-b no-warp gray6">{{ detail.delivery == "2" ? "自提地址" : "收货地址" }}</div>
        <div class="flex-auto pad10-r mar10-b" v-if="dataMasking">{{ detail.orderTransportDtlBo.addr.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
        <div class="flex-auto pad10-r mar10-b" v-else>{{ detail.orderTransportDtlBo.addr }}</div>
      </div>
    </div>
    <div class="item flex-auto border-l pad20-l">
      <div class="fb f16 mar15-b">配送信息</div>
      <div class="flex">
        <div class="w102 mar10-b gray6">配送方式</div>
        <div class="flex-auto mar10-b">{{ detail.delivery == "2" ? "买家自提" : "卖家配送" }}</div>
      </div>
      <div class="flex" v-if="detail.delivery == '1' && detail.orderTransportDtlBo.sellerConfirmPickupTimeStr">
        <div class="w102 mar10-b gray6">预计发货时间</div>
        <div class="flex-auto mar10-b">{{ detail.orderTransportDtlBo.sellerConfirmPickupTimeStr }}</div>
      </div>
      <div class="flex" v-if="detail.delivery == '1' && detail.sendTime">
        <div class="w102 mar10-b gray6">发货时间</div>
        <div class="flex-auto mar10-b">{{ detail.sendTime }}</div>
      </div>
      <div class="flex" v-if="detail.delivery == '2'">
        <div class="w102 mar10-b gray6">自提时间</div>
        <div class="flex-auto mar10-b" v-if="!detail.orderTransportDtlBo.selfPickupTimeType">
          {{ detail.orderTransportDtlBo.pickupTime }}
        </div>
        <div class="flex-auto mar10-b" v-else-if="detail.orderTransportDtlBo.sellerConfirmPickupTimeStr">
          {{ detail.orderTransportDtlBo.sellerConfirmPickupTimeStr }}
          {{ detail.orderTransportDtlBo.sellerConfirmPickupPeriod }}
        </div>
        <div class="flex-auto mar10-b" v-else style="color: #e4ab66">
          {{ "待卖家确认" }}
        </div>
      </div>
      <div class="flex" v-if="detail.orderDtlBo.orderVehicleStatus == 1 && detail.sendTime">
        <div class="w102 mar10-b gray6">确认自提时间</div>
        <div class="flex-auto mar10-b">{{ detail.sendTime }}</div>
      </div>
      <div class="flex" v-if="detail.receiveTime">
        <div class="w102 mar10-b gray6">确认收货时间</div>
        <div class="flex-auto mar10-b">{{ detail.receiveTime }}</div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">买家留言</div>
        <el-tooltip v-bind:content="detail.memo ? detail.memo : '无'" placement="bottom" effect="light">
          <div class="flex-auto mar10-b pad10-r ellipsis_two">{{ detail.memo == "" ? "无" : detail.memo }}</div>
        </el-tooltip>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">卖家留言</div>
        <el-tooltip v-bind:content="detail.memoSeller ? detail.memoSeller : '无'" placement="bottom" effect="light">
          <div class="flex-auto mar10-b pad10-r ellipsis_two">{{ detail.memoSeller == "" ? "无" : detail.memoSeller }}</div>
        </el-tooltip>
      </div>
    </div>
    <div class="item flex-shrink border-l pad20-l">
      <div class="fb f16 mar15-b">发票信息</div>
      <div class="flex">
        <div class="w102 mar10-b gray6">发票种类</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.issueTypeCn != "" ? detail.orderDtlBo.orderInvoice.issueTypeCn : "无" }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">发票类型</div>
        <div class="flex-auto mar10-b">
          {{
            detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.invoicetitleTypeCn != "" ? detail.orderDtlBo.orderInvoice.invoicetitleTypeCn : "无"
          }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">发票抬头</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.receipt != "" ? detail.orderDtlBo.orderInvoice.receipt : "无" }}
        </div>
      </div>
      <div class="flex" v-if="detail.isReceipt === 1">
        <div class="w102 mar10-b gray6">开票状态</div>
        <div class="flex-auto mar10-b">
          {{ detail.invoicePicList && detail.invoicePicList.length > 0 ? "已开票" : "未开票" }}
        </div>
      </div>
      <div class="flex" v-if="detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.contractUrl">
        <div class="w102 mar10-b gray6">协议</div>
        <div class="flex-auto mar10-b">
          <a
            target="_blank"
            v-if="detail.orderDtlBo.orderInvoice.invoiceContractType === 'invoiceSl'"
            :href="detail.orderDtlBo.orderInvoice.contractUrl"
            class="red"
            >权利义务转让协议</a
          >
          <a target="_blank" v-else :href="detail.orderDtlBo.orderInvoice.contractUrl" class="red">代付协议</a>
        </div>
      </div>
      <div class="flex flex-wrap" v-if="detail.invoicePicList && detail.invoicePicList.length > 0">
        <div class="wh64 radius4 mar15-r mar15-b relative overflow" v-for="(invoicePic, index) in detail.invoicePicList" :key="index">
          <el-image
            :src="invoicePic.url + '?imageView2/1/w/64/h/64'"
            v-if="invoicePic.suffix !== 'pdf'"
            :preview-src-list="
              detail.invoicePicList
                .filter((item) => item.suffix !== 'pdf')
                .map((item) => {
                  return item.url;
                })
            "
            :initial-index="index"
          />
          <a v-if="invoicePic.suffix === 'pdf'" :href="invoicePic.url" target="_blank">
            <img src="https://filesouthcdn.nxin.com/nxsc_1691545813992021546671317164323.png?imageView2/1/w/64/h/64" />
          </a>
        </div>
      </div>

      <!-- <div class="flex">
        <div class="w102 mar10-b gray6">纳税人识别号</div>
        <div class="flex-auto mar10-b">
          {{
            detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.taxRegistrationNumber != ""
              ? detail.orderDtlBo.orderInvoice.taxRegistrationNumber
              : "无"
          }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">单位地址</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.companyAddr != "" ? detail.orderDtlBo.orderInvoice.companyAddr : "无" }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">单位电话</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.companyTel != "" ? detail.orderDtlBo.orderInvoice.companyTel : "无" }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">开户银行</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.bankOfDeposit != "" ? detail.orderDtlBo.orderInvoice.bankOfDeposit : "无" }}
        </div>
      </div>
      <div class="flex">
        <div class="w102 mar10-b gray6">银行账号</div>
        <div class="flex-auto mar10-b">
          {{ detail.orderDtlBo.orderInvoice && detail.orderDtlBo.orderInvoice.bankAccount != "" ? detail.orderDtlBo.orderInvoice.bankAccount : "无" }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../order/detail/detail.scss";
</style>

<script>
import requestApi from "@/utils/requestApi";

export default {
  name: "order_basic_info_dtl",
  props: {
    detail: {},
    dataMasking: { type: String },
  },
};
</script>
